module.exports = __webpack_public_path__ + "img/creamy-porridge-with-summer-berries.ef5a0fc6.jpg";